import { LitEntity, html } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import './parts/related-org-list';

class RelatedOrganizationsIndex extends IndexMixin(LitEntity) {
  static get properties() {
    return {
      relatedOrgsHref: { type: String, attribute: false },
    };
  }

  getViews() {
    return [
      {
        default: true,
        name: 'list',
        render: () => html`<related-org-list .href="${this.relatedOrgsHref}"></related-org-list>`,
      },
    ];
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.relatedOrgsHref = this.getHref('https://api.binsentry.com/rel/related-organizations');
  }
}

customElements.define('related-organizations-index', RelatedOrganizationsIndex);
